import React from 'react';

export interface Props {
  percentage: number;
  strength: number;
}

export const Filler = (props: Props) => {
  return <div className={`filler strength-${props.strength}`} style={{ width: `${props.percentage}%` }} />;
};
